module.exports = __webpack_public_path__ + "img/dice-1.c49ce121.svg";